// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2tA1_","rootNoMargin":"styles_rootNoMargin__39EUI"};